import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/firstNvwa',
            name: 'firstNvwa',
            component: () => import('./pages/firstNvwa'),
            meta: {
                title: '久其女娲杯2022'
            }
        },
        {
            path: '/home2023',
            name: 'home2023',
            component: () => import('./pages/home2023'),
            meta: {
                title: '久其女娲杯2023'
            }
        },
        {
            path: '/home2024',
            name: 'home2024',
            component: () => import('./pages/home2024'),
            meta: {
                title: '久其女娲杯2024'
            }
        },
        {
            path: '/home2025',
            name: 'home2025',
            component: () => import('./pages/home2025'),
            meta: {
                title: '久其女娲杯2024'
            }
        },
        {
            path: '/',
            name: 'home',
            component: () => import('./pages/home'),
            meta: {
                title: '久其女娲杯2025'
            }
        }
    ],
    mode:'history'
})
